import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface GeliosCredentials {
  login: string
  password: string
}

interface GeliosState {
  credentials: GeliosCredentials | null
  server: string | null
  setCredentials: (credentials: GeliosCredentials) => void
  setServer: (server: string) => void
  clearCredentials: () => void
  clearServer: () => void
}

export const useGeliosStore = create<GeliosState>()(
  persist(
    (set) => ({
      credentials: null,
      server: null,

      setCredentials: (credentials: GeliosCredentials) => {
        set({ credentials })
      },

      setServer: (server: string) => {
        set({ server })
      },

      clearCredentials: () => {
        set({ credentials: null })
      },

      clearServer: () => {
        set({ server: null })
      },
    }),
    {
      name: 'gelios-storage',
      partialize: (state) => ({
        credentials: state.credentials,
        server: state.server,
      }),
    }
  )
)
